import axios from "axios";
import { configUrl } from "config";

const assignSubscription = async (userId, subscriptionTypeId) => {

    try {

        const response = await axios.post(
            `${configUrl.AssessmentServer}/api/User/assignSubscription`,
            {
                userId,
                subscriptionTypeId
            }
        );

        return response.data;

    } catch (error) {

        console.error(error);
        throw (
            error.response?.data?.message ||
            error.response?.data ||
            error.message ||
            "Something went wrong."
        );

    }
};

export default assignSubscription;
